/**
 * 3D pointer-tilt effect for card elements (like Hearthstone). Sets CSS
 * variables consumed by .ArenaCard's transform — no requestAnimationFrame,
 * so it stays cheap even with several cards on screen at once.
 * Returns a cleanup function to remove the attached listeners.
 */
export default function attachCardTilt(el) {
  const maxTilt = 8; // degrees — subtle tilt

  const onMove = e => {
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width; // 0..1
    const py = (e.clientY - rect.top) / rect.height; // 0..1
    el.style.setProperty('--arena-card-ry', `${((px - 0.5) * maxTilt * 2).toFixed(2)}deg`);
    el.style.setProperty('--arena-card-rx', `${((0.5 - py) * maxTilt * 2).toFixed(2)}deg`);
  };
  const onEnter = () => el.classList.add('ArenaCard--tilting');
  const onLeave = () => {
    el.classList.remove('ArenaCard--tilting');
    el.style.setProperty('--arena-card-rx', '0deg');
    el.style.setProperty('--arena-card-ry', '0deg');
  };
  el.addEventListener('pointerenter', onEnter);
  el.addEventListener('pointermove', onMove);
  el.addEventListener('pointerleave', onLeave);
  return () => {
    el.removeEventListener('pointerenter', onEnter);
    el.removeEventListener('pointermove', onMove);
    el.removeEventListener('pointerleave', onLeave);
  };
}
flarum.reg.add('forumaker-arena', 'common/helpers/attachCardTilt', attachCardTilt);